'use client';

import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { usePathname, redirect } from 'next/navigation';
import { type PropsWithChildren } from 'react';
import { Loader } from '@/components/shared/loader';
import { useFeatureFlags, useLaunchDarkly } from '@/contexts/useFeatureFlags';
import { useRoles } from '@/contexts/useRoles';
import { useSourceAccounts } from '@/contexts/useSourceAccounts';
import { useUser } from '@/contexts/useUser';
import { getDocsUrl } from '@/docs/docsUrls';
export function AuthChecker(t0) {
  const $ = _c(1);
  const {
    children
  } = t0;
  const {
    user,
    currentProjectId
  } = useUser();
  const {
    SkipOnboarding,
    SaasInventoryDefaultLanding
  } = useFeatureFlags();
  const pathname = usePathname();
  const {
    isReady
  } = useLaunchDarkly();
  const {
    sourceAccounts
  } = useSourceAccounts();
  const {
    isGlobalRole,
    roles,
    permissions
  } = useRoles();
  const isApplicationReady = !!user && !!currentProjectId && !!sourceAccounts && isReady && roles.length > 0 && Object.keys(permissions).length > 0;
  if (!isApplicationReady) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <LoaderComponent />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (user.eonAccount?.domain === "eon-docs" && !isGlobalRole(user.selectedRole)) {
    redirect(getDocsUrl("root"));
  }
  if (sourceAccounts?.length || SkipOnboarding || pathname.startsWith("/onboarding") || pathname.startsWith("/global-management")) {
    if (pathname === "/") {
      redirect(SaasInventoryDefaultLanding ? "/saas-inventory" : "/inventory");
    }
    return children;
  }
  redirect("/onboarding");
}
const LoaderComponent = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Box className="h-full" sx={{
      background: "var(--mui-palette-background-pageGradient)"
    }}><Loader /></Box>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};